type Config = {
  ADMINISTRATION_URL: string;
  AUTH0_AUDIENCE: string;
  AUTH0_CLIENT_ID: string;
  AUTH0_DOMAIN: string;
  AUTH0_REDIRECT_URI: string;
  AUTH0_SCOPE: string;
  BASE_URL: string;
  GOOGLE_MAPS_KEY: string;
  GOOGLE_MAPS_MAP_ID_DARKMODE: string;
  GOOGLE_MAPS_MAP_ID_LIGHTMODE: string;
  GRAPHQL_HTTP_ENDPOINT: string;
  GRAPHQL_WS_ENDPOINT: string;
  KEY_PREFIX: string;
  SENTRY_DSN: string;
  STRIPE_KEY: string;
};

const required = (
  key: string,
  defaultValue: string | undefined = undefined,
) => {
  const value = import.meta.env[key] || defaultValue;
  if (value == null) {
    throw new Error(`Key ${key} is undefined`);
  }
  return value;
};

export const config: Config = {
  ADMINISTRATION_URL: required("VITE_ADMINISTRATION_URL"),
  AUTH0_AUDIENCE: required("VITE_AUTH0_AUDIENCE"),
  AUTH0_CLIENT_ID: required("VITE_AUTH0_CLIENT_ID"),
  AUTH0_DOMAIN: required("VITE_AUTH0_DOMAIN"),
  AUTH0_REDIRECT_URI: required("VITE_AUTH0_REDIRECT_URI"),
  AUTH0_SCOPE: required(
    "VITE_AUTH0_SCOPE",
    "openid profile email phone offline_access",
  ),
  BASE_URL: required("VITE_BASE_URL"),
  GOOGLE_MAPS_KEY: required("VITE_GOOGLE_MAPS_KEY"),
  GOOGLE_MAPS_MAP_ID_DARKMODE: required("VITE_GOOGLE_MAPS_MAP_ID_DARKMODE"),
  GOOGLE_MAPS_MAP_ID_LIGHTMODE: required("VITE_GOOGLE_MAPS_MAP_ID_LIGHTMODE"),
  GRAPHQL_HTTP_ENDPOINT: required("VITE_API_ENDPOINT"),
  GRAPHQL_WS_ENDPOINT: required("VITE_API_ENDPOINT").replace("http", "ws"),
  KEY_PREFIX: required("VITE_KEY_PREFIX", "dev_seeitsendit_com_"),
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  STRIPE_KEY: required("VITE_STRIPE_KEY"),
};
